// config/listViewDefaults.js
// ─────────────────────────────────────────────────────────────────────────────
// What a list page's filters are set to the FIRST time a person opens it, by
// role. After that their own last choice wins (hooks/usePersistedPreference,
// keyed per user), so this table is a starting point, not a restriction.
//
// It exists because the product lists are going to be opened by people with
// different jobs: a supervisor working the photo queue should land on
// "Needs photo", a catalogue manager on "Deactivated", and nobody should have
// to click their way to the same view every morning. Each role's entry lists
// only the keys it overrides; anything it leaves out falls back to the base.
//
// Keys are the state names the page uses, values are the chip keys
// (STATUS_FILTERS / PHOTO_FILTERS) or null for "show everything". A role not
// listed here gets the base defaults. Role names are the ones the dashboard
// already reads off `user.result.role` (SUPERADMIN, ADMIN, SUPERUSER,
// SUPERVISOR, BRAND_OWNER, ...).
//
// To RESTRICT a role to a view, rather than merely start it there, the page
// would pass `locked: [...]` to its chips; that is a one-line addition on the
// page when a role needs it, and the entry here is where it would be declared.
// ─────────────────────────────────────────────────────────────────────────────

const BASE = Object.freeze({
  brandProducts: { statusFilter: null, photoFilter: null },
  healthcareMenu: { photoFilter: null },
});

/* Per-role overrides. Empty on purpose until the roles are decided: the
   mechanism ships first so the decision is one line, not a release. */
const BY_ROLE = Object.freeze({
  // SUPERVISOR: { brandProducts: { photoFilter: "needsPhoto" } },
});

/**
 * The starting filters for a page, for a role.
 * @param {string} page   a key of BASE
 * @param {string} [role] `user.result.role`, any case
 */
export const listViewDefaults = (page, role) => {
  const base = BASE[page] || {};
  const forRole = BY_ROLE[String(role || "").toUpperCase()]?.[page] || {};
  return { ...base, ...forRole };
};

export default listViewDefaults;
